import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpandPane = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.3871 5.61282L14.4677 5.61282C14.0976 5.61282 13.7873 5.48761 13.5369 5.23721C13.2865 4.98681 13.1613 4.67653 13.1613 4.30637C13.1613 3.9362 13.2865 3.62592 13.5369 3.37552C13.7873 3.12511 14.0976 2.99991 14.4677 2.99991L19.6936 2.99991C20.0637 2.99991 20.374 3.12511 20.6244 3.37552C20.8748 3.62592 21 3.9362 21 4.30637V9.53217C21 9.90233 20.8748 10.2126 20.6244 10.463C20.374 10.7134 20.0637 10.8386 19.6936 10.8386C19.3234 10.8386 19.0131 10.7134 18.7627 10.463C18.5123 10.2126 18.3871 9.90233 18.3871 9.53217V5.61282Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.6129 18.3871H9.53226C9.90242 18.3871 10.2127 18.5123 10.4631 18.7627C10.7135 19.0131 10.8387 19.3234 10.8387 19.6935C10.8387 20.0637 10.7135 20.374 10.4631 20.6244C10.2127 20.8748 9.90242 21 9.53226 21H4.30645C3.93629 21 3.62601 20.8748 3.37561 20.6244C3.1252 20.374 3 20.0637 3 19.6935L3 14.4677C3 14.0976 3.1252 13.7873 3.37561 13.5369C3.62601 13.2865 3.93629 13.1613 4.30645 13.1613C4.67661 13.1613 4.9869 13.2865 5.2373 13.5369C5.4877 13.7873 5.6129 14.0976 5.6129 14.4677L5.6129 18.3871Z",
		fill: "currentColor"
	})]
});
export default SvgExpandPane;
